import React from 'react';
import styled from '@emotion/styled';
import { ReactComponent as Back } from '../../../../images/remote/keys/back.svg';
import { ReactComponent as Space } from '../../../../images/remote/keys/space.svg';
import { ReactComponent as Enter } from '../../../../images/remote/keys/enter.svg';
import { ReactComponent as Arrows } from '../../../../images/remote/keys/arrows.svg';

export const RemoteShortcutsInfo = () => <RemoteShortCutsContainer>
  <RemoteShortcutsTitle>Keyboard Shortcuts</RemoteShortcutsTitle>
  <RemoteShortcutsSeparator/>
  <RemoteShortcutsIconsContainer>
    <RemoteShortcutIcon Icon={Back} title={'Back'} width={'40%'}/>
    <RemoteShortcutIcon Icon={Space} title={'Play / Pause'} width={'60%'}/>
    <RemoteShortcutIcon Icon={Enter} title={'Select'} width={'35%'}/>
    <RemoteShortcutIcon Icon={Arrows} title={'Navigate'} width={'65%'}/>
  </RemoteShortcutsIconsContainer>
</RemoteShortCutsContainer>;

const RemoteShortcutIcon = ({ Icon, title,width='' }) =>
  <RemoteShortcutIconContainer>
    <Icon width={width}/>
    <RemoteShortcutIconTitle>
      {title}
    </RemoteShortcutIconTitle>
  </RemoteShortcutIconContainer>;

const RemoteShortcutIconContainer = styled.div`
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center;
`;

const RemoteShortcutIconTitle = styled.div`
  font-family: proximanova-regular;
  padding-top: 15%;  
  font-size: 0.85vw;  
  color: rgba(0, 0, 0, 0.85);
`;

const RemoteShortcutsSeparator = styled.div`
    height: 1px;
    width: 77%;
    background-color: rgba(0,0,0,0.1);
    margin: 2% 0 5% 0;
    `;

const RemoteShortcutsTitle = styled.div`
    font-family: proximanova-medium;
    color: rgba(0, 0, 0, 0.85);
    font-size: 1.1vw;
    `;

const RemoteShortCutsContainer = styled.div`
    width: 100%;
    top: -6%;
    position: relative;
    `;

const RemoteShortcutsIconsContainer = styled.div`
    position: relative;
    width: 85%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    left:-5%;
    `;
